import { render, staticRenderFns } from "./vsPopup.vue?vue&type=template&id=0807c91e&lang=html"
import script from "./vsPopup.vue?vue&type=script&lang=js"
export * from "./vsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports